// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3760":"130ebef6","4678":"130ebef6","5017":"9b9aa6f5","5970":"3a2ce501","6449":"9b9aa6f5","7383":"9b9aa6f5","7883":"dfcbfbab","8432":"9b9aa6f5","9962":"9b9aa6f5"}[chunkId] + ".chunk.css";
};